import React from 'react';
import { DatosPersonaEnvio, DatosPersonaEnvioProps } from './DatosPersonaEnvio';
import { DatosRemitente as DatosRemitenteType } from './EnvioNacionalModal.types';
import { PersonaFormFields, getPersonaFieldError } from './EnvioNacionalModal.utils';

export { EMAIL_REGEX } from './EnvioNacionalModal.utils';

export const getErrorMessage = (
  field: keyof DatosRemitenteType,
  datos: DatosRemitenteType,
  errorCodigoPostal?: string | null
): string => getPersonaFieldError(field as keyof PersonaFormFields, datos, errorCodigoPostal);

type Props = Omit<DatosPersonaEnvioProps, 'labels' | 'labelsCO'>;

export const DatosRemitente: React.FC<Props> = (props) => (
  <DatosPersonaEnvio
    {...props}
    labels={{
      titulo: 'Datos del remitente',
      nombre: 'Nombre del remitente',
      colonia: 'Colonia remitente',
    }}
    labelsCO={{
      titulo: 'Datos del remitente',
      nombre: 'Nombre del remitente',
    }}
  />
);
